import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Faq = () => {
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "ld-faq-home";
    el.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(el);
    return () => document.getElementById("ld-faq-home")?.remove();
  }, []);

  return (
  <section data-testid="faq-section" className="py-20 sm:py-28 bg-[#FFFFFF]">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading index="09" eyebrow="Questions" title="Everything buyers ask us" center />
      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={f.q}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-[#DCECC0] rounded-xl px-6 data-[state=open]:border-[#84CC16] transition-colors duration-300"
            >
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-sub font-medium text-[15px] text-[#365314] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm text-[#4D7C0F] leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="text-center mt-10">
          <Link
            to="/best-property-in-new-town-kolkata"
            data-testid="faq-guide-link"
            className="inline-flex items-center gap-2 text-[#365314] text-sm font-sub font-semibold border border-[#9CCB58] rounded-full px-6 py-3 hover:bg-[#EAF5D6] hover:text-[#3F6212] active:scale-[0.98] transition-all duration-300"
          >
            Property Guide for New Town Kolkata
          </Link>
        </p>
      </Reveal>
    </div>
  </section>
  );
};
